import { render } from "./ReviewTab.vue?vue&type=template&id=5be1d44c"
import script from "./ReviewTab.vue?vue&type=script&lang=js"
export * from "./ReviewTab.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__